"use client";

import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function Whats({ config }) {
  if (!config?.configPhone) return null;
  const phone = config.configPhone.find(f => f.type === 'Celular')?.sanitized;
  if (!phone) return null;
  const api = `https://api.whatsapp.com/send/?phone=55${phone}`;
  return (
    <a
      href={ api}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-[60px] h-[60px] rounded-full flex items-center justify-center shadow-lg z-50 transition-transform duration-300 hover:scale-110 animate-pulse-smooth"
    >
      <FaWhatsapp className="text-3xl" />
    </a>
  );
}
